const importAllImages = (context) => {
    let images = {};
  
    context.keys().forEach((key) => {
      const pathParts = key.split('/');
      const folderName = pathParts[pathParts.length - 2]; // Get the second-to-last part, which is the folder name
  
      if (!images[folderName]) images[folderName] = [];
      images[folderName].push(context(key));
    });
  
    return images;
  }
  
  // Load all images from the main directory and all subdirectories
  const allProjectImages = importAllImages(
    require.context('../assets/projectsImages', true, /\.(png|jpe?g|svg|jpg|JPG)$/)
  );
  
  export { allProjectImages };
  